import React from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardText, CircularProgress } from "material-ui";
import { gql, graphql } from "react-apollo";
import moment from "moment";
import { VictoryPie } from "victory";

const VIPLettersQuery = gql`
  query AdminReport($startDate: String!, $endDate: String!) {
    adminReport(startDate: $startDate, endDate: $endDate) {
      vipLetters
    }
  }
`;

const VIPLetters = ({ data, className }) => {
  if (data.loading) {
    return (
      <div style={styles.cardStyles}>
        <Card style={styles.progressContainer}>
          <CardHeader title="VIP Letters" />
          <CircularProgress style={styles.progressIndicator} />
        </Card>
      </div>
    );
  }

  const {
    adminReport: { vipLetters }
  } = data;
  const endDate = moment().add(14, "days");

  const { toDraft, toSend, total, sent } = JSON.parse(vipLetters);

  return (
    <Card className={className}>
      <CardHeader
        title="VIP Letters"
        subtitle={`of ${total} due by ${endDate.format("DDMMM").toUpperCase()}`}
      />
      <CardText>
        <ul>
          <li>
            <strong>{toDraft}</strong> letters to draft of{" "}
            <strong>{total}</strong>
          </li>
        </ul>
        <VictoryPie
          colorScale="warm"
          data={[
            { x: "To Draft", y: toDraft },
            { x: "Drafted", y: total }
          ].sort((a, b) => {
            if (a.y < b.y) {
              return -1;
            }
            if (a.y > b.y) {
              return 1;
            }

            return 0;
          })}
        />
      </CardText>
    </Card>
  );
};

VIPLetters.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string
};

VIPLetters.defaultProps = {
  className: ""
};

export default graphql(VIPLettersQuery, {
  options: {
    variables: {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment()
        .add(14, "days")
        .format("YYYY-MM-DD")
    }
  }
})(VIPLetters);

const styles = {
  ListItemStyles: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    fontSize: 16,
    marginTop: 16,
    marginBottom: 16
  },
  progressContainer: {
    margin: 10,
    position: "relative"
  },
  progressIndicator: {
    marginLeft: "50%",
    left: -20
  }
};



// WEBPACK FOOTER //
// /src/components/Widgets/VIPLetters.js